import { Link } from 'react-router-dom';
import Reveal from '../../components/Reveal/Reveal';
import { IMAGES, PACKAGES, SITE } from '../../app.const';

function Home() {
  return (
    <div className="Home">
      <section className="Home-hero">
        <img className="Home-hero-image" src={IMAGES.vendingTwoPeople.src} alt="" />
        <div className="Home-hero-overlay" />
        <div className="Home-hero-content">
          <p className="Eyebrow">Self-Service, Redefined</p>
          <h1>{SITE.name}</h1>
          <p className="Home-hero-tagline">{SITE.tagline}</p>
        </div>
      </section>

      <Reveal as="section" className="Home-story container">
        <div className="grid Home-story-grid">
          <div className="col-6 Home-story-text">
            <p className="Eyebrow">Our Approach</p>
            <p className="Home-story-statement">{SITE.missionStatement}</p>
          </div>
          <div className="col-6 Home-story-media">
            <div className="u-zoom Home-story-image-frame">
              <img
                className="Home-story-image"
                src={IMAGES.vendingFinger.src}
                alt={IMAGES.vendingFinger.alt}
              />
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal as="section" className="Home-packages container">
        <p className="Eyebrow">Our Packages</p>
        <h2>Curated for every space.</h2>
        <div className="Editorial-list">
          {PACKAGES.map((pkg, index) => (
            <Link className="Editorial-item" to={`/packages#${pkg.id}`} key={pkg.id}>
              <span className="Editorial-index">{String(index + 1).padStart(2, '0')}</span>
              <div className="Editorial-content">
                <h3>{pkg.name}</h3>
                <p>{pkg.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </Reveal>
    </div>
  );
}

export default Home;
